"use client";

import React from "react";
import { Activity, Flame, HeartPulse, Target } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface ApplicationItem {
  id: string;
  title: string;
  description: string;
  icon: React.ComponentType<{
    className?: string;
  }>;
}
const applications: ApplicationItem[] = [{
  id: "general-health",
  title: "General Health & Fitness",
  description: "For people wanting an objective measure of aerobic fitness rather than relying entirely on smartwatch estimates or generic formulas.",
  icon: HeartPulse
}, {
  id: "endurance-performance",
  title: "Endurance & Performance",
  description: "For runners, cyclists, triathletes and other athletes wanting more individualised exercise-intensity information.",
  icon: Activity
}, {
  id: "training-programme-design",
  title: "Training Programme Design",
  description: "For people wanting heart-rate and exercise-intensity information to help structure training more precisely.",
  icon: Target
}, {
  id: "nutrition-body-composition",
  title: "Nutrition & Body Composition",
  description: "RMR can provide measured baseline energy-expenditure information to support wider nutrition and body-composition planning.",
  icon: Flame
}];
export default function ApplicationsOverview() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.15
  });
  return <section id="applicationsoverview" data-nav="light" ref={sectionRef} className="bg-background text-foreground py-16 md:py-24 border-b border-border transition-opacity duration-700 ease-out" style={{
    opacity: isVisible ? 1 : 0
  }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-foreground font-default">
            Useful from everyday health and fitness to competitive sport
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {applications.map((app, index) => {
          const Icon = app.icon;
          return <Card key={app.id} data-index={index} className="bg-card text-card-foreground border border-border rounded-xl shadow-xs hover:shadow-md transition-all duration-300 flex flex-col justify-between">
                <div>
                  <CardHeader className="gap-3 pb-3">
                    <div className="w-10 h-10 rounded-lg bg-secondary text-primary flex items-center justify-center shrink-0">
                      <Icon className="w-5 h-5" />
                    </div>
                    <CardTitle className="text-xl font-semibold text-card-foreground tracking-tight leading-snug">
                      {app.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="pt-0">
                    <CardDescription className="text-muted-foreground text-sm leading-relaxed">
                      {app.description}
                    </CardDescription>
                  </CardContent>
                </div>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}